import React, { useState, useEffect, useCallback } from "react";
import './index.css';
import { useNavigate } from "react-router-dom";
import { useUser } from '../UserContext';
import logo from '../../imagens/TSTRIPAS.png';
import { Link } from "react-router-dom";

const Agenda = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [loadingClientes, setLoadingClientes] = useState(true);
  const [agendamentosReais, setAgendamentosReais] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null); 
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showModalAgendamento, setshowModalAgendamento] = useState(false);

  const [dataAgendamento, setDataAgendamento] = useState('');
  const [horaAgendamento, setHoraAgendamento] = useState('');
  const [descricaoAgendamento, setDescricaoAgendamento] = useState('');
  const [ageTipoAtendimento, setAgeTipoAtendimento] = useState('');
  const [motivoAgendamento, setMotivoAgendamento] = useState('');  

  const [dadosAlteradosAgendamento, setDadosAlteradosAgendamento] = useState([]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  const handleSelectCliente = (cliente) => {
    setSelectedCliente(cliente);
    setSearchTerm(cliente.colNome);
    setShowSuggestions(false);
  };

  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();
    return (
      c.cliId?.toString().includes(termo) ||
      c.colNome?.toLowerCase().includes(termo) ||
      c.colFantasia?.toLowerCase().includes(termo) ||
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });

  // Redireciona se não estiver logado
// Redireciona se não estiver logado ou fora do horário
useEffect(() => {
  if (!userInfo?.username) {
    localStorage.removeItem('userInfo');
    navigate('/');
    return;
  }

  // Se bloqueio por horário estiver ativo
  if (userInfo.bloqueioHorario === 'T') {
    const agora = new Date();
    const horaAtual = agora.getHours();
    const minutoAtual = agora.getMinutes();

    // Converte strings "HH;MM" para números
    const [horaIni, minutoIni] = userInfo.horaInicioLiberado.split(';').map(Number);
    const [horaFim, minutoFim] = userInfo.horaFinalLiberado.split(';').map(Number);

    // Calcula minutos do dia
    const minutosAtuais = horaAtual * 60 + minutoAtual;
    const minutosInicio = horaIni * 60 + minutoIni;
    const minutosFim = horaFim * 60 + minutoFim;

    // Se fora do intervalo permitido
    if (minutosAtuais < minutosInicio || minutosAtuais > minutosFim) {
      alert(`Sistema disponível apenas entre ${horaIni}:${String(minutoIni).padStart(2, '0')} e ${horaFim}:${String(minutoFim).padStart(2, '0')}.`);
      navigate('/menu');
    }
  }
  }, [userInfo, navigate]);

  // Busca clientes e produtos
  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        });
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          setClientes(json);
        } catch (e) {
          console.error('Erro ao converter clientes para JSON:', e);
        }
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingClientes(false);
      }
    };

    fetchClientes();
  }, [userInfo, credentials]);

  // Função para buscar agendamentos da API
  const fetchAgendamentos = useCallback(async () => {
    
    try {

      // Verificar informações necessárias
      if (!userInfo || !userInfo.company || !userInfo.venLogin || !userInfo.venSenha) {
        throw new Error('Informações de login incompletas');
      }

      // Usar exatamente a mesma configuração que funciona no Postman
      const empresa = userInfo.company.split(' ')[0]; // CS
      const credentials = btoa(`${empresa};${userInfo.venLogin}:${userInfo.venSenha}`);
      const url = `${userInfo.url}/agendamento`;

      const headers = {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      
      console.log('📤 Enviando requisição...');
      
      const response = await fetch(url, {
        method: 'GET',
        headers: headers
      });
      
      console.log('📥 Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }
      
      const dados = await response.json();
      
      if (Array.isArray(dados)) {
        if (dados.length === 0) {
          setAgendamentosReais({});
        } else {
          // Processar os dados
          const agendamentosProcessados = processarAgendamentos(dados);
          setAgendamentosReais(agendamentosProcessados);
        }
      } else {
        console.log('❓ Dados não são um array:', dados);
        setAgendamentosReais({});
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar agendamentos:', error);
    } finally {
    }
  }, [userInfo]); // useCallback dependencies

  /*const agendamentoNovo = async () => {
    try {
      fetch(`${userInfo.url}/agendamento`, {
    }*/

  // Função para processar os dados da API para o formato do calendário
    const processarAgendamentos = (dados) => {
        const agendamentos = {};

        if (!Array.isArray(dados)) return agendamentos;

        dados.forEach((item, index) => {
            if (!item.ageDtaAgendamento) return;

            try {
                const partes = item.ageDtaAgendamento.split('T');
                const dataAgendamento = partes[0];
                const horaAgendamento = partes[1] ? partes[1].substring(0, 5) : '00:00';

                const agendamento = {
                    id: item.ageId || index + 1,
                    cliente: item.nomeCliente || 'Cliente não informado',
                    hora: horaAgendamento,
                    descricao: item.ageObservacao || 'Sem descrição',
                    status: item.ageStatusVenda,
                    tipo: item.ageTipoAtendimento,
                    motivo: item.ageMotivoVisita,
                    funcionario: item.nomeFunc || 'Não atribuído',
                    vendedor: item.nomeVendedor || 'Não informado',
                    vendedorId: item.venId || 'Não informado',
                    atendente: item.nomeFunc || 'Não informado',
                    // Corrigido: de '=' para ':'
                    dadosVendedor: { 
                        nome: item.nomeVendedor,
                        venId: item.venId,
                    }
                };

                if (!agendamentos[dataAgendamento]) {
                    agendamentos[dataAgendamento] = [];
                }
                agendamentos[dataAgendamento].push(agendamento);
              } catch (dateError) {
                console.error(`Erro ao processar data:`, dateError);
            }
        });
        return agendamentos;
    };

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoadingClientes(true);
        await new Promise((resolve) => setTimeout(resolve, 2000));
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      } finally {
        setLoadingClientes(false);
      }
    };

    fetchClientes();
  }, []);

  // Carregar agendamentos quando o userInfo estiver disponível
  useEffect(() => {
    if (userInfo && userInfo.venLogin && !loadingClientes) {
      fetchAgendamentos();
    }
  }, [userInfo, loadingClientes, fetchAgendamentos]);

  const formatDate = (date) => {
    // Corrigido: não usar toISOString aqui, pois ele pode mudar o dia se for perto da meia-noite
    // devido ao fuso horário. Pegamos as partes locais do objeto.
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    
    // Adiciona dias vazios do início
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    // Adiciona todos os dias do mês
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  };

  const openModal = (appointment, date) => {
    setSelectedAppointment(appointment);
    setSelectedAppointmentDate(date);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAppointment(null);
    setSelectedAppointmentDate(null);
    setshowModalAgendamento(false);
    setSelectedCliente(null);
    setSearchTerm('');
    setShowSuggestions(false);
    setDataAgendamento('');
    setHoraAgendamento('');
    setDescricaoAgendamento('');
    setAgeTipoAtendimento('');
    setMotivoAgendamento('');
  };

      const handleAgendamentoSubmit = async () => {
      if (!selectedCliente) {
        alert('Por favor, selecione um cliente.');
        return;
      }
      if (!dataAgendamento || !horaAgendamento) {
        alert('Por favor, preencha a data e o horário do agendamento.');
        return;
      }
      if (!ageTipoAtendimento || ageTipoAtendimento === '') {
        alert('Por favor, selecione o tipo de atendimento.');
        return;
      }
      if (!motivoAgendamento || motivoAgendamento === '') {
        alert('Por favor, selecione o motivo do agendamento.');
        return;
      }
      if (!descricaoAgendamento || descricaoAgendamento === '') {
        alert('Por favor, preencha a descrição do agendamento.');
        return;
      } 
  
      try {
        const payload = {
          AGE_STATUS_VENDA: 'Agendado',
          AGE_MOTIVO_VISITA: motivoAgendamento,
          AGE_TIPO_ATENDIMENTO: ageTipoAtendimento,
          AGE_OBSERVACAO: descricaoAgendamento,
          FUN_ID: Number(userInfo.ven_id),
          AGE_DTA_AGENDAMENTO: `${dataAgendamento}T${horaAgendamento}`,
          CLI_ID: Number(selectedCliente.cliId),
          VEN_ID: Number(userInfo.ven_id),
        };
  
        console.log('🚀 Payload montado para envio:', payload);
  
        const response = await fetch(`${userInfo.url}/agendamento`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
          body: JSON.stringify(payload),
        });
  
        if (response.ok) {
          alert('Agendamento realizado com sucesso!');
          setshowModalAgendamento(false);
          fetchAgendamentos(); // Atualiza a lista de agendamentos
        } else {
          const errorData = await response.text();
          console.error('❌ Resposta de erro do servidor:', errorData);
          alert('Erro ao realizar agendamento (Status 500). Verifique o console.');
        }
      } catch (error) {
        console.error('❌ Erro na requisição POST:', error);
        alert('Erro ao realizar agendamento. Verifique a conexão.');
      }
    };

const getCoords = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject("Seu navegador não suporta geolocalização.");
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(`${pos.coords.latitude}, ${pos.coords.longitude}`),
      (err) => {
        // Mensagens amigáveis para erros comuns no iPhone
        let msg = "Erro ao obter localização.";
        if (err.code === 1) msg = "Acesso negado! Ative a localização no Safari/Ajustes do iPhone.";
        if (err.code === 3) msg = "Tempo esgotado! Vá para um local aberto e tente novamente.";
        reject(msg);
      },
      { 
        enableHighAccuracy: true, 
        timeout: 15000, 
        maximumAge: 0 
      }
    );
  });
};

const finalizarAgendamento = async () => { 
  try {
    // 1. Bloqueio: Tenta pegar a localização. 
    // Se der erro, ele pula direto para o CATCH lá embaixo e NÃO executa o fetch.
    //alert("Obtendo localização obrigatória...");
    setLoadingClientes(true);
    const coordenadas = await getCoords(); 

    // 2. Só chega aqui se o getCoords der RESOLVE (sucesso)
    const payload = {
      AGE_STATUS_VENDA: 'Finalizado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: userInfo.ven_id,
      VEN_ID: userInfo.ven_id,
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
      AGE_EQUIPAMENTO: coordenadas, 
    };

    const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
          body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert('Serviço finalizado com sucesso!');
        closeModal();
        fetchAgendamentos();
      } else {
        const errorData = await response.text(); 
        alert(`Erro do servidor: ${errorData}`);
      }

    } catch (error) {
      // Se o erro veio do GPS, ele cai aqui e avisa o usuário.
      console.error('❌ Falha no processo:', error);
      alert(error); // Exibe a mensagem de erro do GPS (ou da requisição)
    }
    finally {
      setLoadingClientes(false);
    }
  };

  const salvarAgendamento = async () => { 

  try {
      const payload = {
      AGE_STATUS_VENDA: selectedAppointment.status || 'Agendado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: userInfo.ven_id,
      VEN_ID: userInfo.ven_id,
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
    };

      console.log('🚀 Payload montado para final:', payload);

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Serviço salvo com sucesso!');
        //console.log('✅ Resposta do servidor:', await response.json());
        closeModal();
        fetchAgendamentos();
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };

  const cancelarAgendamento = async () => { 

  try {
      const payload = {
      AGE_STATUS_VENDA: 'Cancelado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: userInfo.ven_id,
      VEN_ID: userInfo.ven_id,
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
    };

      console.log('🚀 Payload montado para final:', payload);

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Serviço Cancelado com sucesso!');
        //console.log('✅ Resposta do servidor:', await response.json());
        closeModal();
        fetchAgendamentos();
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  const changeMonth = (direction) => {
    setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + direction, 1));
  };

  // Se não tem informações do usuário, mostrar mensagem
  if (!userInfo || !userInfo.venLogin) {
    return (
      <div className="agenda-container">
        <div className="error-message">
          <h2>Acesso não autorizado</h2>
          <p>É necessário fazer login para acessar a agenda.</p>
          <button onClick={() => navigate('/')}>Fazer Login</button>
        </div>
      </div>
    );
  }

  const modalAgendamento = () => {
    setshowModalAgendamento(true);
  };

  return (
    <>
      {loadingClientes ? (
        <div className="loading-container" tabIndex={-1}>
          <img src={logo} alt="Logo" className="loading-logo" />
          <p>Carregando agenda...</p>
        </div>
      ) : (
        <>
          <header className="header">
            <img src={logo} alt="Logo" className="header-logo" />
            <h2>Bem-vindo, {userInfo.username}!</h2>
            {userInfo.controlaFlex === 'T' && (
                <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
                  <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
            {userInfo.descontoFinanceiro === 'T' && (
                <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
                  <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
            <h1>Agenda: {userInfo.company}</h1>
          </header>

          <div className="agenda-container">
            <Link to="/menu" className="link-style">Voltar ao menu</Link>
            <div className="agenda-header">
            <h1>Agenda</h1>
            <button className="btn-cadastro" onClick={() => modalAgendamento()}>
              + Novo Agendamento
            </button>
            <button className="btn-cadastro" onClick={() => navigate('/venda')}>
              Cadastro de Pedidos
            </button>
          </div>

                <div className="calendar-container">
                    <div className="calendar-header">
                      <button className="nav-btn" onClick={() => changeMonth(-1)}>‹</button>
                      <h2>{monthNames[selectedDate.getMonth()]} {selectedDate.getFullYear()}</h2>
                      <button className="nav-btn" onClick={() => changeMonth(1)}>›</button>
                    </div>

                    {/* Calendário */}
                    <div className="calendar-grid">
                        {dayNames.map(day => (
                          <div key={day} className="day-header">{day}</div>
                        ))}
                        
                        {getDaysInMonth(selectedDate).map((day, index) => {
                          if (!day) return <div key={index} className="empty-day"></div>;
                          
                          const dateStr = formatDate(day);
                          const dayAppointments = agendamentosReais[dateStr] || [];
                          const isToday = formatDate(new Date()) === dateStr;
                          
                          // Debug: Log para verificar as datas
                          if (dayAppointments.length > 0) {
                            console.log(`Data: ${dateStr}, Agendamentos:`, dayAppointments);
                          }
                          
                          return (
                            <div key={index} className={`calendar-day ${isToday ? 'today' : ''} ${dayAppointments.length > 0 ? 'has-appointments' : ''}`}>
                              <div className="day-number">{day.getDate()}</div>
                                <div className="appointments">
                                  {dayAppointments
                                    .filter(appointment => {
                                      // Se não houver vendedor selecionado, mostra todos. 
                                      // Se houver, mostra apenas o que coincide com o nome.
                                      return appointment.vendedorId === userInfo.ven_id || userInfo.venLogin === appointment.vendedorId;
                                    })
                                    .map(appointment => (
                                      <div 
                                        key={appointment.id} 
                                        className={`appointment-item ${appointment.status?.toLowerCase() === 'agendado' ? 'appointment-agendado' : appointment.status?.toLowerCase() === 'finalizado' ? 'appointment-finalizado' : 'appointment-cancelado'}`}
                                        onClick={() => openModal(appointment, dateStr)}
                                      >
                                        <span className="appointment-time">{appointment.hora}</span>
                                        <span className="appointment-client">{appointment.cliente}</span>
                                        <span className="appointment-client">{appointment.atendente}</span>
                                        <span className="appointment-client">{appointment.status}</span>
                                      </div>
                                    ))
                                  }

                                </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
          
                    {/* Modal */}
                    {showModal && selectedAppointment && (
                      <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                          <div className="modal-header">
                            <h3>Detalhes do Agendamento</h3>
                            <button className="close-btn" onClick={closeModal}>×</button>
                          </div>
                          
                          <div className="modal-body">
                            <div className="detail-item">
                              <label>Cliente:</label>
                              <span>{selectedAppointment.cliente}</span>
                            </div>
                            
                            <div className="detail-item">
                              <label>Data:</label>
                              <input 
                                type="date" 
                                name="data" // O segredo está aqui!
                                value={dadosAlteradosAgendamento.data || selectedAppointmentDate} // Mostra a data original se não houver alteração
                                disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}
                                onChange={(e) => {
                                  const { name, value } = e.target; // Pega "data" e o valor digitado

                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value // Atualiza a chave "data" com o novo valor
                                  }));
                                }} 
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Hora:</label>
                              <input 
                                type="time" 
                                name="hora" // O segredo está aqui!
                                value={dadosAlteradosAgendamento.hora || selectedAppointment.hora} 
                                disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Status:</label>
                              <span className={`status-badge ${selectedAppointment.status?.toLowerCase() === 'agendado' ? 'status-agendado' : 'status-finalizado'}`}>
                                {selectedAppointment.status}
                              </span>
                            </div>
                            
                            <div className="detail-item">
                              <label>Tipo Agendamento:</label>
                              <select 
                                className={`status-badge ${selectedAppointment.tipo?.toLowerCase() === 'telefone' ? 'status-telefone' : 'status-visita'}`}
                                name='tipo'
                                value={dadosAlteradosAgendamento.tipo || selectedAppointment.tipo}
                                disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}
                                onChange={(e) => {
                                  const { name, value } = e.target;   
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              >
                                <option value="">Selecione o status</option>
                                <option value="TELEFONE">Telefone</option>
                                <option value="VISITA">Visita</option>
                              </select>
                            </div>
          
                            <div className="detail-item">
                              <label>Motivo Agendamento:</label>
                              <select 
                                name='motivo'
                                value={dadosAlteradosAgendamento.motivo || selectedAppointment.motivo}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                                disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}
                              >
                                <option value="">Selecione o motivo</option>
                                <option value="LEAD">LEAD</option>
                                <option value="VENDA">VENDA</option>
                                <option value="VISITA PRESENCIAL">VISITA PRESENCIAL</option>
                                <option value="VISITA TECNICA">VISITA TECNICA</option>
                              </select>
                            </div>
                            
                            <div className="detail-item">
                              <label>Descrição:</label>
                              <textarea 
                                name='descricao'
                                value={dadosAlteradosAgendamento.descricao || selectedAppointment.descricao}
                                disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              />
                            </div>
                          </div>
                          
                          <div className="modal-footer">
                            <button className="btn-secondary" onClick={closeModal}>
                              Voltar
                            </button>
                            <button className="btn-secondary" onClick={cancelarAgendamento} disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}>
                              Cancelar
                            </button>
                            <button className="btn-secondary" onClick={salvarAgendamento} disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}>
                              Salvar
                            </button>
                            <button className="btn-primary" onClick={finalizarAgendamento} disabled={selectedAppointment.status === 'Finalizado' || selectedAppointment.status === 'Cancelado'}>
                              Finalizar
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
          
                    {/* Modal Agendamento novo */}
                    {showModalAgendamento &&(
                      <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                          <div className="modal-header">
                            <h3>Novo Agendamento</h3>
                            <button className="close-btn" onClick={closeModal}>×</button>
                          </div>
                          
                          <div className="modal-body">
                            <div className="detail-item">
                              <label>Cliente:</label>
                              <div className="cliente-box">
                                <input
                                  type="text"
                                  placeholder="Pesquisar cliente..."
                                  value={selectedCliente ? selectedCliente.colFantasia : searchTerm}
                                  onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setSelectedCliente(null);
                                    setShowSuggestions(true);
                                  }}
                                  onFocus={() => setShowSuggestions(true)}
                                />
                                  {searchTerm && (
                                    <button
                                      className="clear-button"
                                      title="Limpar pesquisa"
                                      onClick={() => {
                                        setSearchTerm('');
                                        setShowSuggestions(false); // ou true, se quiser manter a lista aberta
                                        setSelectedCliente(null);
                                      }}
                                    >
                                      ❌
                                    </button>
                                  )}
            
                                  {/* 🔹 Lista de sugestões (só aparece se showSuggestions for true) */}
                                  {showSuggestions && searchTerm && (
                                    <ul className="detail-item">
                                      {filteredClientes.length > 0 ? (
                                        filteredClientes.map((c, index) => (
                                          <li key={`${c.cliId}-${index}`} onClick={() => handleSelectCliente(c)}>
                                            {c.cliId} - <strong>{c.colNome}</strong> <br /> {c.colFantasia}
                                          </li>
                                        ))
                                      ) : (
                                        <li>❌ Nenhum cliente encontrado</li>
                                      )}
                                    </ul>
                                  )}
                              </div>
                            </div>
                            
                            <div className="detail-item">
                              <label>Data:</label>
                              <input
                                type="date"
                                value={dataAgendamento}
                                onChange={(e) => setDataAgendamento(e.target.value)}
                                required
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Hora:</label>
                              <input type="time" 
                              value={horaAgendamento} 
                              onChange={(e) => setHoraAgendamento(e.target.value)}
                              required
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Tipo Agendamento:</label>
                              <select 
                              value={ageTipoAtendimento} 
                              onChange={(e) => setAgeTipoAtendimento(e.target.value)}
                              required
                              >
                                <option value="">Selecione o status</option>
                                <option value="TELEFONE">TELEFONE</option>
                                <option value="VISITA">VISITA</option>
                              </select>
                            </div>
          
                            <div className="detail-item">
                              <label>Motivo Agendamento:</label>
                              <select 
                              value={motivoAgendamento} 
                              onChange={(e) => setMotivoAgendamento(e.target.value)}
                              required
                              >
                                <option value="">Selecione o status</option>
                                <option value="LEAD">LEAD</option>
                                <option value="VENDA">VENDA</option>
                                <option value="VISITA PRESENCIAL">VISITA PRESENCIAL</option>
                                <option value="VISITA TECNICA">VISITA TECNICA</option>
                              </select>
                            </div>
                            
                            <div className="detail-item">
                              <label>Descrição:</label>
                              <textarea
                                value={descricaoAgendamento}
                                onChange={(e) => setDescricaoAgendamento(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          
                          <div className="modal-footer">
                            <button className="btn-secondary" onClick={closeModal}>
                              Voltar
                            </button>
                            <button className="btn-primary" onClick={handleAgendamentoSubmit}>
                              Enviar Agendamento
                            </button>
                          </div>
                        </div>
                      </div>
                    )}          
          </div>
        </>
      )}
    </>
  );
};

export default Agenda;
